import { render, staticRenderFns } from "./TabCancel.vue?vue&type=template&id=206cb22e&"
import script from "./TabCancel.vue?vue&type=script&lang=js&"
export * from "./TabCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports